import { useEffect, useSyncExternalStore } from 'react';

let current: { text: string; id: number } | null = null;
const listeners = new Set<() => void>();
let seq = 0;

export function toast(text: string) {
  current = { text, id: ++seq };
  for (const l of listeners) l();
}

export function Toasts() {
  const t = useSyncExternalStore(
    (l) => {
      listeners.add(l);
      return () => listeners.delete(l);
    },
    () => current,
  );
  useEffect(() => {
    if (!t) return;
    const id = setTimeout(() => {
      if (current?.id === t.id) {
        current = null;
        for (const l of listeners) l();
      }
    }, 3200);
    return () => clearTimeout(id);
  }, [t]);
  if (!t) return null;
  return (
    <div className="toast" role="status" key={t.id}>
      {t.text}
    </div>
  );
}
